module.exports = __webpack_public_path__ + "img/marina-fedorina.c79a1d58.jpg";